import TermsOfUseModal from "../../components/TermsOfUse/TermsOfUse";
import ImpressumModal from "../../components/Impressum/Impressum";
import ReleaseNotes from "../../components/ReleaseNotes/ReleaseNotes";

export const version = "1.2.0";

const Footer = () => {
    return (
        <footer className="pr-4 pl-4 flex bg-base-300 text-base-content shrink-0 h-12 overflow-hidden justify-between items-center">
            <span className="text-gray-400 pl-4">{`Version: ${version}`}</span>
            <div className="flex items-center">
                <ReleaseNotes headerText="Release Notes" />
                <TermsOfUseModal headerText="Nutzungsbedingungen" />
                <ImpressumModal headerText="Impressum:" />
            </div>
        </footer>
    );
};

export default Footer;
